import { render, staticRenderFns } from "./WeForest.vue?vue&type=template&id=5451d2bd&scoped=true&"
import script from "./WeForest.vue?vue&type=script&lang=js&"
export * from "./WeForest.vue?vue&type=script&lang=js&"
import style0 from "./WeForest.vue?vue&type=style&index=0&id=5451d2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451d2bd",
  null
  
)

component.options.__file = "WeForest.vue"
export default component.exports